import { render, staticRenderFns } from "./BaseConfirmSupport.vue?vue&type=template&id=6228980f&scoped=true&"
import script from "./BaseConfirmSupport.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmSupport.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirmSupport.vue?vue&type=style&index=0&id=6228980f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228980f",
  null
  
)

export default component.exports